import { Link } from "react-router-dom";

interface LogoProps {
  className?: string;
}

const Logo = ({ className = "" }: LogoProps) => {
  return (
    <Link to="/" className={`flex items-center gap-2 ${className}`}>
      <img
        src="/logo.png"
        alt="CastReady Logo"
        width="135"
        height="40"
        className="h-10 w-auto"
        decoding="async"
      />
    </Link>
  );
};

export default Logo;
